export default function Footer() {
    return (
        <footer className="relative py-[10px] bg-[#1B1A1F]">
            <div className="container flex items-center text-center text-white font-bold justify-center">
                Copyright ©️ 2025 M Power Moving Services. All Rights Reserved.
            </div>
        </footer>
    )
}